import { render, staticRenderFns } from "./stepNavigation.vue?vue&type=template&id=ef461f08&scoped=true"
import script from "./stepNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./stepNavigation.vue?vue&type=script&setup=true&lang=js"
import style0 from "./stepNavigation.vue?vue&type=style&index=0&id=ef461f08&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef461f08",
  null
  
)

export default component.exports